import transport_alt from "./Content/images/transporter_logo.png";
import CryptoJS from "crypto-js";
import { Constants, API_LOGO_BASE_URL, DECRPTION_KEY_HEX } from './Constants';
import * as XLSX from "xlsx";

const FileUrl = API_LOGO_BASE_URL;

export const getInitials = (name) => {
  if (!name) return "T";
  let ini = name.split(" ");
  let initials = "";
  if (ini.length > 1) initials = ini[0].charAt(0) + ini[1].charAt(0);
  else if (ini.length === 1) initials = ini[0].charAt(0);
  else if (ini.length === 0) initials = "T";
  return initials.toLocaleUpperCase();
};

const extractDomain = (value) => {
  if (!value || !value.includes("@")) return null;
  return value.split("@")[1]?.trim().toLowerCase() || null;
};

export const isPersonalEmailDomain = (value) => {
  const domain = extractDomain(value);
  if (!domain) return false;
  return Constants.personalEmailDomains.some((entry) => entry.trim().toLowerCase() === domain);
};

export const isRestrictedDomain = (value) => {
  const domain = extractDomain(value);
  if (!domain) return false;
  return Constants.restrictedDomains.some((entry) =>
    entry instanceof RegExp ? entry.test(domain) : entry.trim().toLowerCase() === domain
  );
};

export const isValidBusinessEmail = (value) => {
  const regexValid =
    value &&
    new RegExp(Constants.Email.regex).test(value.trim()) &&
    new RegExp(Constants.Email.emailRegex).test(value.trim());
  if (!regexValid) return false;
  const domain = extractDomain(value);
  if (!domain) return false;
  return !isPersonalEmailDomain(value) && !isRestrictedDomain(value);
};

export const ImportAll = (r) => {
  let imports = {};
  r.keys().map((item) => (imports[item.replace("./", "")] = r(item)));
  return imports;
};
export const hasValue = (value) => { };

export const getCompanyFolderName = function () {
  let domain = localStorage.getItem("useremail")
    ? localStorage.getItem("useremail").split("@").pop()
    : "unknown-company";
  domain = domain.replace(/\./g, "-");
  return domain;
};

export const getUserFolderName = function () {
  return localStorage.getItem("useremail")
    ? localStorage.getItem("companyid")
    : "unknown-user";
};

export const getTimeStamp = function () {
  var dateString = new Date().toISOString();
  dateString = dateString.replace(/-/g, "_");
  dateString = dateString.replace("T", "__");
  dateString = dateString.replace(/:/g, "_");
  return dateString.split(".")[0];
};

export const Images = ImportAll(
  require.context("./Content/images", false, /\.(png|jpe?g|svg)$/)
);

export const PrepareSequentialArray = (count) => {
  let array = [];

  if (!count || count < -1) return array;

  for (let i = 1; i <= count; i++) {
    array.push(i);
  }

  return array;
};

export const UpsertElementToArray = (
  array = [],
  newOrUpdatedElement,
  keyToCompareBy
) => {
  return array.some(
    (e) => e[keyToCompareBy] === newOrUpdatedElement[keyToCompareBy]
  )
    ? UpdateElementToArray(array, newOrUpdatedElement, keyToCompareBy)
    : array.concat(newOrUpdatedElement);
};

export const UpdateElementToArray = (array, updatedElement, keyToCompareBy) =>
  array.map((e) =>
    e[keyToCompareBy] === updatedElement[keyToCompareBy] ? updatedElement : e
  );

export const ReplaceOrInsertValueForKeyInArrayElement = (
  array = [],
  key,
  newVal
) => {
  if (array.some((el) => el[key])) {
    return array.map((el) => {
      if (el[key]) {
        el[key] = newVal;
      }
      return el;
    });
  } else {
    const newArr = array.slice();
    newArr.push({ [key]: newVal });
    return newArr;
  }
};

export const scrollToEndofDiv = (childId, parentId = "app-body") => {
  var div = document.getElementById(childId);
  const body = document.getElementById(parentId);
  if (div && body && body.scrollTo) {
    body.scrollTo({ top: div.scrollHeight, behavior: "smooth" });
  }
};

export const findDuplicateInArray = (list, key) => {
  let duplicatedValue = false;
  list.map((element) => {
    if (
      list.filter(
        (t) => t[key].trim().toLowerCase() === element[key].trim().toLowerCase()
      ).length > 1
    ) {
      duplicatedValue = element[key];
      return;
    }
  });
  return duplicatedValue;
};

export const getNewGuid = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};
export const generateReactSelectOptions = (opts = [], key, trimmed) =>
  opts.map((o) =>
    trimmed
      ? { label: o[key], value: o[key] }
      : { ...o, label: o[key], value: o[key] }
  );
export const getImageSrc = (logo) => {
  if (logo && logo.length > 1) return `${FileUrl}/${logo}`;
  return transport_alt;
};
export const imageFallBack = (e) => {
  e.target.src = transport_alt;
};
export const getFileIconCss = (fileName) => {
  if (!fileName || !fileName.trim()) return "";

  const ext = fileName.split(".").pop();
  const fileType = Constants.FileTypes.find(
    (f) => f.extension === ext.trim().toLowerCase()
  );
  const invalidFile = Constants.FileTypes.find(
    (f) => f.extension === "invalid"
  );

  return fileType || invalidFile;
};
export const titleCase = (str = "") => {
  if (typeof str !== "string") return "";
  var splitStr = str.toLowerCase().split(" ");
  for (var i = 0; i < splitStr.length; i++) {
    // You do not need to check if i is larger than splitStr length, as your for does that for you
    // Assign it back to the array
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  // Directly return the joined string
  return splitStr.join(" ");
};
export const Uppercase = (text = "") => {
  return text ? text.toUpperCase() : "";
};

export const scrollToTop = function (DomId) {
  document.getElementById(DomId).scrollTop = 0;
};
export const checkIndentAccess = function (transporter, moduleName) {
  const hasModule = transporter.modules?.some(
    (module) => module.module_name === moduleName && module.access === "yes"
  );
  return hasModule;
};
export const checkModuleAccess = function (
  access_control,
  contact_number,
  module,
  company_name
) {
  if (access_control && access_control.length > 0) {
    var company_accessible_list = [];
    var access_user = {};
    // var access = {}
    for (var i = 0; i < access_control.length; i++) {
      if (access_control[i].modules && access_control[i].modules.length > 0) {
        for (var j = 0; j < access_control[i].modules.length; j++) {
          if (
            access_control[i].modules[j].module_name === module &&
            access_control[i].modules[j].access === "yes" &&
            access_control[i].modules[j].company_accessible &&
            access_control[i].modules[j].company_accessible.length > 0
          ) {
            if (access_control[i].contact_number === contact_number) {
              access_user = access_control[i].modules[j];
            }
            for (
              var k = 0;
              k < access_control[i].modules[j].company_accessible.length;
              k++
            ) {
              if (
                access_control[i].modules[j].module_name === "Company Enquiries"
              ) {
                company_accessible_list.push(
                  access_control[i].modules[j].company_accessible[k].domain
                );
              } else {
                company_accessible_list.push(
                  access_control[i].modules[j].company_accessible[k]
                    .company_name
                );
              }
            }
          }
        }
      }
    }
    // console.log(access, access_user, access_control, company_accessible_list, contact_number, company_name)
    if (company_accessible_list.includes(company_name)) {
      // console.log('if')
      if (
        access_user &&
        access_user.company_accessible &&
        access_user.company_accessible.length > 0
      ) {
        // console.log('if2')
        for (var x = 0; x < access_user.company_accessible.length; x++) {
          // console.log('for1')
          if (
            access_user.company_accessible[x].company_name &&
            access_user.company_accessible[x].company_name === company_name &&
            access_user.module_name !== "Company Enquiries"
          ) {
            // console.log('if3')
            return true;
          } else if (
            access_user.company_accessible[x].domain &&
            access_user.company_accessible[x].domain === company_name &&
            access_user.module_name === "Company Enquiries"
          ) {
            // console.log('if4')
            return true;
          }
        }
      }
      return false;
    } else {
      return true;
    }
  } else {
    return true;
  }
};
export const DateFormatForHistory = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  const milliseconds = String(date.getMilliseconds()).padStart(3, "0");
  const timezoneOffset = -date.getTimezoneOffset();
  const timezoneOffsetHours = Math.floor(Math.abs(timezoneOffset) / 60)
    .toString()
    .padStart(2, "0");
  const timezoneOffsetMinutes = (Math.abs(timezoneOffset) % 60)
    .toString()
    .padStart(2, "0");
  const timezoneSign = timezoneOffset >= 0 ? "+" : "-";

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}${timezoneSign}${timezoneOffsetHours}:${timezoneOffsetMinutes}`;
};

export const sqlInjectionPatterns =
  /(select\s*\*\s*from)|(sleep\s*\(\s*\d+\s*\))|(insert\s+into\s+\w+\s*\([^)]*\)\s*values\s*\([^)]*\))/i;

export const addTotalTruckAllocation = (lspData, truckLoad) => {
  const temp = lspData;

  const newLspData = temp?.map((lsp) => {
    return {
      ...lsp,
      total_truck_allocation: Math.round(
        (parseInt(lsp.business_share) / 100) * parseInt(truckLoad)
      ),
    };
  });
  return newLspData;
};

/**
 * Decrypts a base64 encoded, AES-encrypted response using a hex key.
 *
 * @function
 * @param {string} encryptedResponse - The base64 encoded encrypted response to decrypt.
 * @returns {Object|null} The decrypted JSON object, or null if decryption fails.
 */
export const decryptResponse = (encryptedResponse) => {
  try {
    let hex_key = DECRPTION_KEY_HEX;
    const key = CryptoJS.enc.Hex.parse(hex_key);
    // Convert the base64 encoded string to a WordArray
    const encryptedDataWithIV = CryptoJS.enc.Base64.parse(encryptedResponse);

    // Extract the IV and the encrypted data
    const iv = CryptoJS.lib.WordArray.create(
      encryptedDataWithIV.words.slice(0, 4)
    );
    const encryptedData = CryptoJS.lib.WordArray.create(
      encryptedDataWithIV.words.slice(4)
    );

    // Decrypt the data
    const decryptedData = CryptoJS.AES.decrypt(
      { ciphertext: encryptedData },
      key,
      { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
    );

    // Convert the decrypted data to a string
    const decryptedStr = CryptoJS.enc.Utf8.stringify(decryptedData);

    // Parse the JSON string into an object
    return JSON.parse(decryptedStr);
  } catch (error) {
    console.error("Decryption failed:", error);
    return null;
  }
};

export const encryptPayload = (payload) => {
  try {
    // Retrieve the key from environment variables
    let hex_key = DECRPTION_KEY_HEX;

    const key = CryptoJS.enc.Hex.parse(hex_key);
    // Generate a random Initialization Vector (IV)
    const iv = CryptoJS.lib.WordArray.random(16); // AES uses 16 bytes IV
    // Convert the payload to a string
    const payloadStr = JSON.stringify(payload);
    // Encrypt the payload
    const encryptedData = CryptoJS.AES.encrypt(payloadStr, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    // Combine the IV and the encrypted data
    const ivAndEncryptedData = CryptoJS.lib.WordArray.create([
      ...iv.words,
      ...encryptedData.ciphertext.words,
    ]);
    // Encode the combined result to base64
    const encryptedResponse = CryptoJS.enc.Base64.stringify(ivAndEncryptedData);
    return encryptedResponse;
  } catch (error) {
    console.error("Encryption failed:", error);
    return null;
  }
};
export const isSuperUser = (contact_info) => {
  let isSuperAdmin;
  let organizationList = [];
  let isOrgListPresent = false;
  if (contact_info && contact_info.length > 0) {
    contact_info.map((item) => {
      if (item.email === localStorage.getItem("useremail")) {
        if (item.organization && item.organization.length > 0) {
          organizationList = item.organization;
          isOrgListPresent = true;
        } else {
          isOrgListPresent = false;
          let companyName = localStorage.getItem("companyname") ?? "company";
          organizationList = [{ name: companyName, id: "company" }];
        }
      }
    });
  }
  return { isSuperAdmin, organizationList, isOrgListPresent };
};

export const handleFileChange = (e, setFile, setData, setStep, viewed) => {
  const file = e.target.files[0];
  if (!file) return;
  setFile(file);
  const reader = new FileReader();
  reader.onload = (event) => {
    const data = new Uint8Array(event.target.result);
    const workbook = XLSX.read(data, { type: "array" });
    const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
    if (!firstSheet) {
      toast.error("No data found in the sheet");
      return;
    }

    // Read the entire data as an array of arrays
    const allData = XLSX.utils.sheet_to_json(firstSheet, { header: 1 });
    // Check if there is at least one row of data
    if (allData.length > 0) {
      // Ensure there's at least the header and one row of data
      const headers = allData[0]; // Get the header row
      // Create an array of objects in label-value format
      // const labelValueArray = headers.map((header, index) => ({
      //   label: header,
      //   value: header // Use empty string if no value
      // }));
      const labelValueArray = headers
        .filter(
          (header) => header !== "" && header !== null && header !== undefined
        )
        .map((header, index) => ({
          label: header,
          value: header, // Use empty string if no value
        }));

      // Check for completely empty columns
      const _emptyColumns = [];
      const columnCount = headers.length;
      const rowCount = allData.length;
      let finalInvalids = [];
      for (let col = 0; col < columnCount; col++) {
        let isEmpty = true;

        for (let row = 1; row < rowCount; row++) {
          if (allData[row][col] !== undefined && allData[row][col] !== "") {
            isEmpty = false;
            break;
          } else {
            finalInvalids.push(`In ${allData[0][col]}, row ${row} is Empty`);
          }
        }
        // setIsInvalidData(finalInvalids);
        if (isEmpty) {
          _emptyColumns.push(headers[col]);
        }
      }
      // if (!isUploadFileScreen) {
      setData(labelValueArray); // Use setData to store the label-value objects
      // setEmptyColumns(_emptyColumns)
      // }
      // Store the label-value array in state
      if (viewed) {
        setStep(1)
      } else if (finalInvalids.length === 0) {
        setStep(1)
      }
      // else {
      // if (!isUploadFileScreen) {
      // setStep(4)
      // }
      // }
      // } else {
      // if (!isUploadFileScreen) {
      // setData([]); // Use setData to store the label-value objects
      // setEmptyColumns([])
      // }
    }
  };
  setStep(1)
  reader.readAsArrayBuffer(file); // Read the file as an ArrayBuffer
};

export const isValidUrl = (urlString) => {
  try {
    new URL(urlString);
    return true;
  } catch (_) {
    return false;
  }
};
